
import { defineComponent, PropType } from "@vue/runtime-core";
import AbstractExercise from "./AbstractExercise.vue";
import { exerciseProps } from "./shared";
import DrawEditor from "../../ui/DrawEditor.vue";
import { v4 as uuid4 } from "uuid";

export default defineComponent({
	name: "OpenAnswerExercise",
	props: {
		...exerciseProps,
	},
	mounted() {
		// check if this element is child of a .thumbnail-slot
		setTimeout(() => {
			const el = document.getElementById(this.elementId);
			if (!el) {
				throw new Error("DrawExercise: Element not found");
			}
			const thumbnailSlot = el?.closest(".thumbnail-slot");
			this.renderDrawEditor = !thumbnailSlot;
		}, 100);
	},
	data() {
		return {
			renderDrawEditor: false,
			elementId: `a-${uuid4()}`,
		};
	},
	methods: {
		onChange(data: any) {
			this.$emit("updateSubmission", ["answer_text", JSON.stringify(data)]);
			setTimeout(() => {
				this.$emit("blur");
			}, 200);
		},
	},
	computed: {
		initialData() {
			const submission = this.submission.answer_text ?? "{ elements: [], files: {} }";
			try {
				const { elements, files } = JSON.parse(submission);
				return { elements, files };
			} catch {
				return { elements: [], files: {} };
			}
		},
		answerImage() {
			const submission = this.submission.answer_text ?? `{ image: "" }`;
			try {
				const { image } = JSON.parse(submission);
				return image;
			} catch {
				return [];
			}
		},
		// answerTextProxy: {
		// 	get() {
		// 		return this.submission.answer_text;
		// 	},
		// 	set(val: string) {
		// 		this.$emit("updateSubmission", ["answer_text", val]);
		// 	},
		// },
	},
	components: { AbstractExercise, DrawEditor },
});
